var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('path',{attrs:{"d":"M3 3L22 22","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3 22L22 3","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }